import React from "react";

import { observable, toJS, makeObservable, action } from "mobx";
import { CrudCommon } from "../_common/CrudCommon";
import { AppStore } from "~/stores/AppStore";
import { v4 as uuidv4, v1 as uuid } from "uuid";
import Chance from "chance";
import { Checkbox, Divider, Form, Input, InputNumber, Select, TimePicker, Modal } from "antd";
import _ from "lodash";
import { translateKey as t } from "../../../locales/translation";
import dayjs from "dayjs";
import { getSheetNames } from "./components/modals/DataImporter/templates";
import Papa from "papaparse";
import * as XLSX from "xlsx";
import {
  generateRandomNumber,
  generateClusterRef,
  getRandomArrayElement,
  generateRandomCoordinates,
  generateSharedLocationValue,
  copyTextToClipboard,
  extractErrorMessage,
  mongoId,
  getRandomArrayElementPreferFirst,
} from "../../../utils/helpers";
import { annotatePartners } from "../../../utils/partnerEnvironment";

type activeFlagDependant = {
  flag: boolean;
  keyDirectory: string;
};

export class ClientsController {
  public store: AppStore;
  public selectedClient: any = null;
  public clients: Array<any> = [];
  public isSelectedReadOnly = false;
  public currentTab = "general";
  public jsonViewer: any = null;
  public newClientModal: any = {
    visible: false,
  };

  public cloneClientModal: any = {
    visible: false,
    source: null,
  };

  public partners: Array<any> = [];

  public editClientWizardModal: any = {
    visible: false,
    loading: false,
    clientData: null,
    wizardData: null,
  };

  public verticals: Array<any> = [];
  public countries: Array<any> = [];
  public errors: Array<any> = [];
  public apiLoading: boolean = false;
  public depots: Array<any> = [];
  public selectedDepots: Array<any> = [];
  public selectedDates: Array<any> = [];

  public chance = new Chance();

  //-------DATA IMPORTER---------------------------------------------------------------------------

  public loading: boolean = false;
  // public postDataErrors: Array<any> = [];
  public dataImportTemplates: Array<any> = [];

  public importerErrorsModal: any = {
    visible: false,
  };

  public resetMasterDataModal: any = {
    visible: false,
    loading: false,
    row: null,
  };

  public demoDataPostModal: any = {
    visible: false,
    loading: false,
    row: null,
  };

  public saveScenarioSnapshotModal: any = {
    visible: false,
    loading: false,
    clientRow: null,
    spinMessage: "",
  };

  public loadScenarioSnapshotModal: any = {
    visible: false,
    loading: false,
    clientRow: null,
    spinMessage: "",
  };

  public deleteScenarioSnapshotModal: any = {
    visible: false,
    loading: false,
    spinMessage: "",
  };

  public clientSettingsModal: any = {
    visible: false,
    loading: false,
    row: null,
    dataStructure: [],
    selectedOption: null,
    backups: [], // store 3 backups
    currentProfile: null, //store the CURRENT profile of the client
    editProfile: null, //store the EDIT profile of the client
    editMode: false,
    compareModalVisible: false,
  };

  //----------------------------------------------------------------------------------

  public dataImporterModal: any = {
    visible: false,
    loading: false,
    row: null,
    uploadLoading: false,
    importedData: [],
    file: null,
    postDataErrors: [],
    preDataErrors: [],
  };
  // public importedData = [];
  //----------------------------------------------------------------------------------

  // public driversInfo: any = {
  //   file: null,
  //   data: [],
  //   error: [],
  //   validated: false,
  // };
  // public depotsInfo: any = {
  //   file: null,
  //   data: [],
  //   error: [],
  //   validated: false,
  // };
  // public vehiclesInfo: any = {
  //   file: null,
  //   data: [],
  //   error: [],
  //   validated: false,
  // };
  // public multiCsvInfo: any = {
  //   file: null,
  //   data: [],
  //   error: [],
  //   validated: false,
  // };

  //----------------------------------------------------------------------------------
  public formRef: any;
  public clientSettingsFormRef: any;
  public crudCommon: CrudCommon;
  public formMode = "create";
  public entitySnapshot = "";
  public passwordChanged = false;
  public fields: Array<any> = [
    { Header: t("lblActive", "Active"), id: "active", type: "boolean" },
    { Header: t("lblUsername", "Username"), id: "username" },
    { Header: t("lblEmail", "Email"), id: "email" },
    { Header: t("lblFirstName", "First Name"), id: "firstName" },
    { Header: t("lblLastName", "Last Name"), id: "lastName" },
    { Header: t("lblDepots", "Depots"), id: "depots" },
    { Header: t("lblRoles", "Roles"), id: "roles" },
  ];

  public routeGroups: Array<any> = [];
  public roles: Array<any> = [];
  public providers: Array<any> = [];

  public mainDataHasLoaded = false;
  public additionalColumnsAreVisible = false;
  public isReadOnly = false;
  public isFormModalVisible = false;
  public saveButtonLoading = false;
  public tableInstance: any = null;
  public deleteModal: any = {
    visible: false,
    description: "",
  };
  public tableIsReadOnly = true;
  // public saveModal: any = { visible: false, onConfirmSave: () => this.handleTableSubmit() }
  // public isDiscardChangesModalVisible = false

  public modifiedRows: any = [];
  public multiSelectKeyPressed = false;
  public shiftKeyPressed = false;
  public clickedRow: any = {};

  // Used for the form's options
  public modalOptionsLocalStorageKey = "usersFormModalOptions";
  public formFieldsSize: "small" | "middle" | "large" = "middle";
  public formModalSize: "small" | "default" | "large" = "default";
  public showNonMandatoryFields = true;
  public showFieldsIcon = false;
  public showPasswords = false;
  public prerequisitesLoaded = true;
  public postTypes = ["routes"];

  public scenarioSnapshots: Array<any> = [];

  // private dropColintegratedApiPolicy = {
  //   ref: "dropCollections",
  //   resource: "/clients/drop-collections",
  //   methods: [
  //     {
  //       method: "POST",
  //       enable: true,
  //       authorisedGrantTypes: [
  //         {
  //           grantType: "client_credentials",
  //           scopes: ["admin"],
  //         },
  //       ],
  //     },
  //   ],
  // };

  // private integratedApiPolicyV2 = {
  //   ref: "integrated-api-policy-v2",
  //   resource: "/integration-api-policies",
  //   methods: [
  //     {
  //       method: "POST",
  //       enable: true,
  //       authorisedGrantTypes: [
  //         {
  //           grantType: "client_credentials",
  //           scopes: ["admin"],
  //         },
  //       ],
  //     },
  //   ],
  // };

  constructor(store) {
    this.store = store;
    this.crudCommon = new CrudCommon(this, "users");

    makeObservable(this, {
      clients: observable,
      selectedClient: observable,
      tableInstance: observable,
      isSelectedReadOnly: observable,
      currentTab: observable,
      jsonViewer: observable,
      newClientModal: observable,
      cloneClientModal: observable,
      partners: observable,
      editClientWizardModal: observable,
      verticals: observable,
      countries: observable,
      errors: observable,
      dataImporterModal: observable,
      demoDataPostModal: observable,
      clientSettingsModal: observable,
      resetMasterDataModal: observable,
      // driversInfo: observable,
      // depotsInfo: observable,
      // vehiclesInfo: observable,
      // multiCsvInfo: observable,
      apiLoading: observable,
      depots: observable,
      selectedDepots: observable,
      selectedDates: observable,
      // importedData: observable,
      // postDataErrors: observable,
      dataImportTemplates: observable,
      importerErrorsModal: observable,

      setImporterErrorsModal: action,
      setDataImportTemplates: action,
      // setPostDataErrors: action,
      setSelectedDates: action,
      setSelectedDepots: action,
      setApiLoading: action,
      setVerticals: action,
      setCountries: action,
      setErrors: action,
      setJsonViewer: action,
      setCurrentTab: action,
      setIsSelectedReadOnly: action,
      setClients: action,
      setSelectedClient: action,
      setTableInstance: action,
      setNewClientModal: action,
      setCloneClientModal: action,
      setPartners: action,
      setEditClientWizardModal: action,
      setResetMasterDataModal: action,
      setDemoDataPostModal: action,
      setClientSettingsModal: action,
      setDataImporterModal: action,
      // setDriversInfo: action,
      // setDepotsInfo: action,
      // setVehiclesInfo: action,
      // setMultiCsvInfo: action,
      setDepots: action,
      //-MODALS----------------------------------------------------
      saveScenarioSnapshotModal: observable,
      loadScenarioSnapshotModal: observable,
      deleteScenarioSnapshotModal: observable,
      scenarioSnapshots: observable,
      setScenarioSnapshots: action,
      setSaveScenarioSnapshotModal: action,
      setLoadScenarioSnapshotModal: action,
      setDeleteScenarioSnapshotModal: action,
      //-----------------------------------------------------
      formRef: observable,
      crudCommon: observable,
      formMode: observable,
      entitySnapshot: observable,
      passwordChanged: observable,
      fields: observable,
      routeGroups: observable,
      roles: observable,
      providers: observable,
      mainDataHasLoaded: observable,
      additionalColumnsAreVisible: observable,
      isReadOnly: observable,
      isFormModalVisible: observable,
      saveButtonLoading: observable,
      deleteModal: observable,
      tableIsReadOnly: observable,
      modifiedRows: observable,
      multiSelectKeyPressed: observable,
      shiftKeyPressed: observable,
      clickedRow: observable,
      modalOptionsLocalStorageKey: observable,
      formFieldsSize: observable,
      formModalSize: observable,
      showNonMandatoryFields: observable,
      showFieldsIcon: observable,
      showPasswords: observable,
      prerequisitesLoaded: observable,
      postTypes: observable,

      //ACTIONS
      setAdditionalColumnsAreVisible: action,
      setSaveButtonLoading: action,
      setFormMode: action,
      setEntitySnapshot: action,
      setMainDataHasLoaded: action,
      setIsFormModalVisible: action,
      setEntity: action,
      pushClient: action,
    });

    // This value is set in the User Routes CRUD
    this.isReadOnly = this.store.isRouteReadOnly(window.location.pathname);

    this.setFormModalOptions();
  }

  //------------------------SETTERS--------------------------------------------------------------

  // public setPostDataErrors(value: Array<any>) {
  //   this.postDataErrors = value;
  // }
  public setDataImportTemplates(value: Array<any>) {
    this.dataImportTemplates = value;
  }

  public setSelectedDates(value: Array<any>) {
    this.selectedDates = value;
  }

  public setSelectedDepots(value: Array<any>) {
    this.selectedDepots = value;
  }

  public setDepots(value: Array<any>) {
    this.depots = value;
  }

  // public setDriversInfo(key: string, value: any) {
  //   if (key) {
  //     this.driversInfo[key] = value;
  //   } else {
  //     this.driversInfo = value;
  //   }
  // }

  // public setDepotsInfo(key: string, value: any) {
  //   if (key) {
  //     this.depotsInfo[key] = value;
  //   } else {
  //     this.depotsInfo = value;
  //   }
  // }

  // public setVehiclesInfo(key: string, value: any) {
  //   if (key) {
  //     this.vehiclesInfo[key] = value;
  //   } else {
  //     this.vehiclesInfo = value;
  //   }
  // }

  // public setMultiCsvInfo(key: string, value: any) {
  //   if (key) {
  //     this.multiCsvInfo[key] = value;
  //   } else {
  //     this.multiCsvInfo = value;
  //   }
  // }

  public setDataImporterModal(key: string, value: any) {
    if (key) {
      this.dataImporterModal[key] = value;
    } else {
      this.dataImporterModal = value;
    }
  }

  public setImporterErrorsModal(key: string, value: any) {
    if (key) {
      this.importerErrorsModal[key] = value;
    } else {
      this.importerErrorsModal = value;
    }
  }

  public setClientSettingsModal(key: string, value: any) {
    if (key) {
      this.clientSettingsModal[key] = value;
    } else {
      this.clientSettingsModal = value;
    }
  }

  public setDemoDataPostModal(key: string, value: any) {
    console.log("setDemoDataPostModal", key, value);

    if (key) {
      this.demoDataPostModal[key] = value;
    } else {
      this.demoDataPostModal = value;
    }
  }

  public setSaveScenarioSnapshotModal(key: string, value: any) {
    if (key) {
      this.saveScenarioSnapshotModal[key] = value;
    } else {
      this.saveScenarioSnapshotModal = value;
    }
  }

  public setLoadScenarioSnapshotModal(key: string, value: any) {
    if (key) {
      this.loadScenarioSnapshotModal[key] = value;
    } else {
      this.loadScenarioSnapshotModal = value;
    }
  }

  public setDeleteScenarioSnapshotModal(key: string, value: any) {
    if (key) {
      this.deleteScenarioSnapshotModal[key] = value;
    } else {
      this.deleteScenarioSnapshotModal = value;
    }
  }

  public setResetMasterDataModal(key: string, value: any) {
    if (key) {
      this.resetMasterDataModal[key] = value;
    } else {
      this.resetMasterDataModal = value;
    }
  }

  public setNewClientModal(key: string, value: any) {
    this.newClientModal[key] = value;
  }

  public setCloneClientModal(key: string, value: any) {
    if (key) {
      this.cloneClientModal[key] = value;
    } else {
      this.cloneClientModal = value;
    }
  }

  public setPartners(value: Array<any>) {
    this.partners = value;
  }

  public loadPartners = async () => {
    try {
      const partners = await this.store.getData("partners", "main");
      if (partners) {
        // PRO-84: flag every partner with whether it is served by the OpenFleet stack this console is bound to.
        this.setPartners(annotatePartners(partners, this.store.user.ofProviderUrl));
      }
    } catch (err) {
      this.store.displayNotification(t("lblFailedToLoadPartners", "Failed to Load Partners"), "error", true, extractErrorMessage(err));
    }
  };

  public cloneClient = async (payload) => {
    this.store.setPreLoaderProps({
      loading: true,
      loadingText: t("lblCloningClient", "Cloning client..."),
    });

    try {
      await this.store.postData("clients/clone", payload, "pro_client");

      this.store.setPreLoaderProps({ loading: false, loadingText: "" });
      this.store.displayNotification(t("lblCloneQueued", "Clone queued. The new client will appear shortly."), "success", true);
      this.setCloneClientModal(null, { visible: false, source: null });
    } catch (err) {
      this.store.setPreLoaderProps({ loading: false, loadingText: "" });
      this.store.displayNotification(t("lblFailedToCloneClient", "Failed to Clone Client"), "error", true, extractErrorMessage(err));
    }
  };

  public setEditClientWizardModal(key: string, value: any) {
    if (key) {
      this.editClientWizardModal[key] = value;
    } else {
      this.editClientWizardModal = value;
    }
  }

  public setScenarioSnapshots(value: any) {
    this.scenarioSnapshots = value;
  }

  public setJsonViewer(value: any) {
    this.jsonViewer = value;
  }

  public setVerticals(value: any) {
    this.verticals = value;
  }

  public setCountries(value: any) {
    this.countries = value;
  }

  public setErrors(value: Array<any>) {
    this.errors = value;
  }

  public setCurrentTab(value: string) {
    this.currentTab = value;
  }

  public setApiLoading(value: boolean) {
    this.apiLoading = value;
  }

  public setIsSelectedReadOnly(value: boolean) {
    this.isSelectedReadOnly = value;
  }

  public setClients(value: Array<any>) {
    this.clients = value;
  }

  public pushClient(value: Object) {
    this.clients.push(value);
  }

  public setSelectedClient(value: any, key: string = null) {
    if (key === null) {
      this.selectedClient = value;
      this.deleteModal.verificationField = value.clientRef;
    } else {
      this.selectedClient[key] = value;
    }
  }

  public setTableInstance(value: any) {
    this.tableInstance = value;
  }

  // === LOADING ===
  public async loadDependencies() {
    this.setApiLoading(true);

    // await this.store.setClient("DEMO-UK");
    // this.loadDepots();

    let promises = [];

    promises.push(this.loadClients());
    promises.push(this.loadVerticals());
    promises.push(this.loadCountries());

    Promise.all(promises).then(() => {
      this.setApiLoading(false);
      this.setMainDataHasLoaded(true);
    });
  }

  public async loadClients() {
    try {
      //let clients = await this.store.getData("clients", "pro_client");
      let clients = await this.store.getData(`partners/${this.store.user.client}/clients`, "pro_client");

      if (clients) {
        if (this.store.user.roles.includes("DEMO_USER")) {
          clients = clients.filter((client) => client.proOptions?.demo);
        }

        clients.forEach((cl) => {
          let formattedUpdatedAt = null;
          let formattedCreatedAt = null;

          if (cl?.updatedAt) {
            formattedUpdatedAt = dayjs(_.get(cl, "updatedAt"));
          }

          if (cl?.updatedAt) {
            formattedCreatedAt = dayjs(_.get(cl, "createdAt"));
          }

          cl.formattedUpdatedAt = formattedUpdatedAt;
          cl.formattedCreatedAt = formattedCreatedAt;

          let disableResetMasterData = true;
          if (cl?.dbName?.includes("of-pro")) {
            disableResetMasterData = false;
          }

          cl.disableResetMasterData = disableResetMasterData;
        });

        let sortedClients = _.sortBy(clients, ["proOptions.master", "createdAt"]);

        this.setClients(sortedClients);
      }
    } catch (err) {
      this.store.displayNotification(t("lblFailedToLoadClients", "Failed to Load Clients"), "error", true, extractErrorMessage(err));

      // this.store.stopOverlayLoader()
    }
  }

  public async loadDepots() {
    try {
      const depots = await this.store.getData("depots", "intapi", true);
      if (depots) {
        this.setDepots(depots);
      }
    } catch (error) {
      this.store.displayNotification(t("lblFailedToLoadDepots", "Failed to Load Depots"), "error", true, extractErrorMessage(error));
      throw error;
    }
  }

  public async getClientSettings() {
    try {
      // const sampleSettingsStructure = require("./clientSettingsTest.json");
      const sampleSettingsStructure = require("./clientSettings.json");
      const currentData = require("./DCG_ClientSettings.json");

      const groupedData = sampleSettingsStructure.reduce((acc, item) => {
        item.section.forEach((section) => {
          if (!acc[section]) {
            acc[section] = [];
          }
          acc[section].push(item);
        });

        // Sort each section so items with 'data' key are last
        Object.keys(acc).forEach((section) => {
          acc[section].sort((a, b) => {
            const aHasData = "data" in a;
            const bHasData = "data" in b;
            if (aHasData === bHasData) return 0;
            return aHasData ? 1 : -1;
          });
        });

        return acc;
      }, {});

      let passedSettings = {
        settingsStructure: groupedData,
        backups: [],
        currentProfile: currentData,
        editProfile: currentData,
      };

      return passedSettings;
    } catch (err) {
      this.store.displayNotification(t("lblFailedToGetSettings", "Failed to Get Settings"), "error", true, extractErrorMessage(err));
    }
  }

  loadVerticals = async () => {
    try {
      const verticals = await this.store.getData("verticals", "main", false, null);

      if (verticals) {
        this.setVerticals(verticals.result);
      }
    } catch (err) {
      this.store.displayNotification(t("lblFailedToLoadVerticals", "Failed to Load Verticals"), "error", true, extractErrorMessage(err));

      // this.store.stopOverlayLoader()
    }
  };

  loadCountries = async () => {
    try {
      const countries = await this.store.getData("countries", "main", false, null);

      if (countries) {
        this.setCountries(countries.result);
      }
    } catch (err) {
      this.store.displayNotification(t("lblFailedToLoadCountries", "Failed to Load Countries"), "error", true, extractErrorMessage(err));

      // this.store.stopOverlayLoader()
    }
  };

  // PRO-84: the console talks to a single OpenFleet stack, so clients cannot be created here for a partner that is
  // served by another stack. Fail fast before posting; the stack API performs the authoritative check and rejects
  // such requests with PARTNER_NOT_ALLOWED_ON_STACK.
  private assertPartnerInCurrentEnvironment = (partner: any) => {
    if (partner && partner.isCurrentEnvironment === false) {
      const ref = partner.clientRef || partner.ref || partner.name || partner._id;

      throw new Error(t("lblPartnerEnvironmentMismatch", "Partner {1} is served by another OpenFleet environment; log in as that partner to create its clients", [ref]));
    }
  };

  createClient = async (client, overwrite) => {
    //send whole object instead of ref to pro_client api
    client.country = this.countries.find((country) => country.ref === client.country);

    const { partnerId, ...clientPayload } = client;
    const selectedPartner = partnerId ? this.partners.find((p) => p._id === partnerId) : null;
    this.assertPartnerInCurrentEnvironment(selectedPartner);

    const options = {
      client: clientPayload,
      partner: selectedPartner
        ? { _id: selectedPartner._id, ref: selectedPartner.clientRef || selectedPartner.ref }
        : {
            _id: this.store.user.client,
            ref: this.store.user.clientRef,
          },
      user: this.store.user,
    };

    await this.store.postData("clients", options, "pro_client");
  };

  createClientWithWizard = async (config) => {
    // Prepare client data
    const client = {
      clientRef: config.clientRef,
      name: config.name,
      vertical: config.vertical,
      country: this.countries.find((country) => country.ref === config.country),
      demo: config.demo,
    };

    // Prepare wizard configuration
    const wizardConfig = config.wizardConfig;

    const selectedPartner = config.partnerId ? this.partners.find((p) => p._id === config.partnerId) : null;
    this.assertPartnerInCurrentEnvironment(selectedPartner);

    const options = {
      client: client,
      token: this.store.user.ofAccessToken,
      wizardConfig: wizardConfig,
      partner: selectedPartner
        ? { _id: selectedPartner._id, ref: selectedPartner.clientRef || selectedPartner.ref }
        : {
            _id: this.store.user.client,
            ref: this.store.user.clientRef,
          },
      user: this.store.user,
    };

    console.log("createClientWithWizard options", options);

    // Post to the new wizard endpoint
    await this.store.postData("clients/wizard", options, "pro_client");
  };

  updateClientWithWizard = async (clientId, wizardConfig) => {
    const options = {
      wizardConfig: wizardConfig,
      user: this.store.user,
    };

    console.log("updateClientWithWizard options", options);

    // Put to the wizard endpoint
    await this.store.putData(`clients/wizard`, options, "pro_client", true);
  };

  fetchClientWizardConfig = async (clientId: string) => {
    try {
      this.setEditClientWizardModal("loading", true);

      const response = await this.store.getData(`clients/wizard`, "pro_client", true);

      if (response) {
        return response;
      }

      throw new Error("Failed to fetch client wizard configuration");
    } catch (err) {
      this.store.displayNotification(t("lblFailedToLoadClientConfig", "Failed to Load Client Configuration"), "error", true, extractErrorMessage(err));
      throw err;
    } finally {
      this.setEditClientWizardModal("loading", false);
    }
  };

  openEditClientWizard = async (client: any) => {
    try {
      this.setEditClientWizardModal("loading", true);
      this.setEditClientWizardModal("visible", true);

      // Fetch the client's wizard configuration
      const wizardConfig = await this.fetchClientWizardConfig(client._id);

      wizardConfig.dispatchView.enableCustomerPromiseTimeWindow = wizardConfig.dispatchView?.calculateCustomerPromiseTimeWindow ? true : false;

      // Prepare client data
      const clientData = {
        clientRef: client.clientRef,
        name: client.name,
        vertical: client.proOptions?.vertical,
        country: client.proOptions?.country,
        demo: client.proOptions?.demo || false,
      };

      this.setEditClientWizardModal("clientData", clientData);
      this.setEditClientWizardModal("wizardData", wizardConfig);
      this.setEditClientWizardModal("clientId", client._id);
    } catch (err) {
      this.setEditClientWizardModal(null, {
        visible: false,
        loading: false,
        clientData: null,
        wizardData: null,
      });
    }
  };

  deleteClients = async () => {
    console.log("deleteClients", this.selectedClient);
    await this.store.deleteData(`clients/${this.selectedClient._id}`, "pro_client");
  };

  resetMasterData = async (verticalRef = "COU", demo = false) => {
    this.store.setPreLoaderProps({
      loading: true,
      loadingText: `Resetting Master Data`,
    });

    this.setResetMasterDataModal(null, {
      visible: false,
      loading: false,
      row: null,
    });

    const options = {
      user: this.store.user,
    };

    await this.store.postData("clients/reset", options, "pro_client", true);
    //now we wait fot socket updates to show progress
  };

  finishClientCreateResetProcess = async (isClientReset, dispatcherMessage, isCurrentUser) => {
    //new client created
    if (!isClientReset && dispatcherMessage?.client) {
      this.pushClient(dispatcherMessage.client);
      if (isCurrentUser) {
        this.store.selectedClient = dispatcherMessage.client.clientRef;
      }
    }

    //all client actions
    if (isCurrentUser) {
      this.openNewClientSuccessModal(isClientReset);
      this.store.clearClient();
    }
  };

  openNewClientSuccessModal = (isClientReset) => {
    Modal.success({
      title: `Client ${isClientReset ? "Reset" : "Created"} Successfully`,
      content: (
        <div>
          <p className="mb-3">Please use the following credentials on first login:</p>
          <div className="bg-gray-100 rounded-lg p-3 pl-5">
            <div className="flex mb-1">
              <div className="w-32">
                <b>Client:</b>
              </div>
              <div>{this.store.selectedClient}</div>
            </div>
            <div className="flex mb-1">
              <div className="w-32">
                <b>Username:</b>
              </div>
              <div>{this.store.user.username}</div>
            </div>
            <div className="flex">
              <div className="w-32">
                <b>Password:</b>
              </div>
              <div>Welcome123!</div>
            </div>
          </div>
          <p className="mb-3">
            <b>Note:</b> User will be forced to change password on first login.
          </p>
        </div>
      ),
      width: 500,
    });
  };

  // postTemplatesIndividually = async (masterData) => {
  //   for (const item of masterData.result) {
  //     try {
  //       let url = this.checkForDepotPrefix(item.depot, masterData.template);

  //       if (masterData.template === "routing-permissions" || masterData.template === "dispatch-permissions") {
  //         url = `${masterData.template}/${item._id}`;
  //       }

  //       const data = await this.store.postData(url, item, masterData.virtualPath, true);
  //       console.log(data);
  //     } catch (err) {
  //       console.error(err.message);
  //       if (err.response?.status === 404 || err.response?.status === 400) {
  //         //ignore skill-profiles until error is fixed
  //         if (masterData.template !== "skill-profiles") {
  //           break;
  //         }
  //       }
  //     }
  //   } // for item loop end
  // };

  postTemplatesBulk = async (masterData) => {
    try {
      let payload = {};
      const groupKey = masterData.virtualPath === "mdapi" ? "data" : "items";

      payload[groupKey] = [];

      masterData.result.forEach((item) => {
        if (masterData.virtualPath === "mdapi") {
          payload[groupKey].push(item);
        } else {
          payload[groupKey].push({ data: item });
        }
      });

      //let url = this.checkForDepotPrefix(masterData.result[0].depot, masterData.template) + "/bulkCreate";
      let url = masterData.template;

      if (masterData.virtualPath !== "mdapi") {
        url += "/bulkCreate";
      }

      const data = await this.store.postData(url, payload, masterData.virtualPath, true);
      console.log(data);
    } catch (err) {
      throw err;
    }
  };

  // checkForDepotPrefix = (depot, templateName) => {
  //   let depotPrefix = "";
  //   let depotId = depot;

  //   if (depot && templateName !== "default-settings") {
  //     if (typeof depot === "object") {
  //       depotId = depotId._id;
  //     }

  //     depotPrefix = `depots/${depotId}/`;
  //   }

  //   return depotPrefix + templateName;
  // };

  handleTemplateDownload = (type) => {
    let fileName = "";
    let excelFile = null;

    switch (type) {
      case "masterData":
        excelFile = require("./MasterDataTemplate.xlsx");
        fileName = "MasterDataTemplate.xlsx";
        break;
      case "mobileData":
        excelFile = require("./MobileDataTemplate.xlsx");
        fileName = "MobileDataTemplate.xlsx";
        break;
    }

    const link = document.createElement("a");
    link.href = excelFile;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  handleUploadFile = () => {
    this.setDataImporterModal("uploadLoading", true);

    let currentFile = this.dataImporterModal.file;

    const reader = new FileReader();

    reader.onload = async (e) => {
      const dataImportTemplates = await this.store.getData("templates/import", "main", false);

      if (dataImportTemplates.result) this.setDataImportTemplates(dataImportTemplates.result);

      const data = new Uint8Array(e.target.result as ArrayBuffer);
      const workbook = XLSX.read(data, { type: "array" });
      let importedData = [];
      let importErrors = [];
      workbook.SheetNames.forEach((sheetName) => {
        //get sheet mapping from db
        const sheetMapping = this.dataImportTemplates?.find((template) => template.sheetName === sheetName);

        if (getSheetNames().includes(sheetName) && sheetMapping) {
          // const sheetColumns = sheetMapping.fields;
          const sheet = workbook.Sheets[sheetName];

          // FUTURE IMPROVEMENT: See how to handle spanned cells

          // Convert the sheet to CSV format
          const csvData = XLSX.utils.sheet_to_csv(sheet);

          // Parse the CSV data using PapaParse
          Papa.parse(csvData, {
            header: false,
            complete: (result) => {
              //Filter out the rows that are not enmpty
              let filteredArray = result.data.filter((subArray) => subArray.some((field) => field !== ""));

              //Get index for getting rows
              // const guidelinesIndex = result.data.findIndex((subArray) => subArray[0] === "Data Fields Input Guidelines");
              const datasetIndex = result.data.findIndex((subArray) => subArray[0] === "Dataset") + 4;
              // console.log(datasetIndex);
              // console.log(guidelinesIndex);

              //Get index for parsing data
              let dataFieldsInputGuidelines = [];
              let dataset = [];
              const findIndexOfGuidelines = filteredArray.findIndex((subArray) => subArray[0] === "Data Fields Input Guidelines");
              const findIndexOfDataset = filteredArray.findIndex((subArray) => subArray[0] === "Dataset");

              dataFieldsInputGuidelines = filteredArray.slice(findIndexOfGuidelines + 1, findIndexOfDataset);
              let dataColumns = filteredArray[findIndexOfDataset + 1];

              dataset = filteredArray.slice(findIndexOfDataset + 2, filteredArray.length);

              // console.log("dataFieldsInputGuidelines", dataFieldsInputGuidelines); //This is not used for now
              // console.log("dataset", dataset);
              // console.log("dataColumns", dataColumns);
              // console.log("sheetName", sheetName);

              const headers = dataFieldsInputGuidelines[0].slice(0, -1); // Get the headers name as this will be the object keys
              const columnProps = dataFieldsInputGuidelines.slice(1).map((row) => {
                const obj: any = {};
                headers.forEach((key, index) => {
                  obj[key] = row[index];
                });
                return obj;
              });
              // console.log("columnProps", columnProps);

              let parsedData = [];

              if (dataset.length > 0) {
                dataset.forEach((dataCollection, rowIndex) => {
                  let newObject = {
                    // errors: [],
                  };
                  let errors = [];
                  const uniquErrorsId = uuid();

                  dataCollection.forEach((item, index) => {
                    //Get fieldName
                    let columnName = dataColumns[index].charAt(0).toLowerCase() + dataColumns[index].slice(1);
                    let value = null;

                    //Entity Properties
                    let uniqueFlag = _.get(columnProps[index], "Unique?", false) === "TRUE" ? true : false;
                    let mandatoryFlag = _.get(columnProps[index], "Mandatory?", false) === "TRUE" ? true : false;

                    let minValue = _.get(columnProps[index], "Min Value", null);
                    let maxValue = _.get(columnProps[index], "Max Value", null);

                    //check field type
                    let passedColumnType = _.get(columnProps[index], "Type", null);

                    let primaryType; //- variable type
                    let valueLength; //- will contain the count if available
                    let childrenType; //- will contain children type when primarytype is list

                    if (passedColumnType != null) {
                      if (passedColumnType.toLowerCase().includes("list")) {
                        primaryType = "list";
                        childrenType = "string";
                        const match = passedColumnType.match(/\(\s*(\d+)\s*\)/); // capture whats inside the ()
                        valueLength = match.length > 0 ? parseInt(match[1]) : "N/A";
                      } else {
                        if (passedColumnType.toLowerCase().includes("string")) {
                          primaryType = "string";
                          const match = passedColumnType.match(/\(\s*(\d+)\s*\)/); // capture whats inside the ()
                          valueLength = match != null ? parseInt(match[1]) : "N/A";
                        } else {
                          primaryType = passedColumnType;
                        }
                      }

                      switch (primaryType.toLowerCase()) {
                        case "string":
                          value = item;

                          //length defined
                          if (valueLength !== undefined && valueLength !== "N/A") {
                            if (value.trim().length > valueLength) {
                              errors.push({
                                sheetName: sheetName,
                                ref: dataColumns[index],
                                message: "Value entered exceeds specified length",
                                data: value,
                                id: uniquErrorsId,
                                rowNumber: rowIndex + datasetIndex,
                              });
                            }
                          }

                          break;
                        case "boolean":
                          value = item === "TRUE" ? true : false;
                          break;
                        case "list":
                          const listArray = item.split("|");

                          if (valueLength !== undefined && valueLength !== "N/A" && childrenType.toLowerCase() === "string") {
                            listArray.forEach((val, index) => {
                              if (val.length > valueLength) {
                                errors.push({
                                  sheetName: sheetName,
                                  ref: dataColumns[index],
                                  message: "Value entered exceeds specified length",
                                  data: val,
                                  id: uniquErrorsId,
                                  rowNumber: rowIndex + datasetIndex,
                                });
                              }
                            });
                          }

                          value = listArray;
                          break;
                        case "selection":
                          value = item;
                          break;
                        case "number":
                        case "decimal":
                        case "integer":
                        case "double":
                          value = item;

                          if (minValue !== null && minValue !== "N/A") {
                            if (parseFloat(value) < parseFloat(minValue)) {
                              errors.push({
                                sheetName: sheetName,
                                ref: dataColumns[index],
                                message: "Value entered is less than Min value allowed",
                                data: value,
                                id: uniquErrorsId,
                                rowNumber: rowIndex + datasetIndex,
                              });
                            }
                          }

                          if (maxValue !== null && minValue !== "N/A") {
                            if (parseFloat(value) > parseFloat(maxValue)) {
                              errors.push({
                                sheetName: sheetName,
                                ref: dataColumns[index],
                                message: "Value entered is more than Max value allowed",
                                data: value,
                                id: uniquErrorsId,
                                rowNumber: rowIndex + datasetIndex,
                              });
                            }
                          }

                          break;
                        case "time":
                          const [hourPart, minutePart = 0] = String(item).split("."); // Handle decimal hours (if any)
                          const formattedHour = hourPart.padStart(2, "0"); // Ensure two-digit hour format
                          const formattedMinute = String(minutePart).padEnd(2, "0");

                          value = `${formattedHour}:${formattedMinute}`;
                          break;
                      }
                    } else {
                      console.log("Column is probably a linked ref");
                      value = item;
                    }

                    //Check if value is unique
                    if (uniqueFlag) {
                      if (parsedData.find((pd) => pd[columnName] === value)) {
                        errors.push({
                          sheetName: sheetName,
                          ref: this.formatText(dataColumns[index]),
                          message: "Value entered is not unique",
                          data: value,
                          id: uniquErrorsId,
                          rowNumber: rowIndex + datasetIndex,
                        });
                      }
                    }

                    if (mandatoryFlag) {
                      if (primaryType.toLowerCase() !== "boolean" && (value === null || value?.trim()?.length === 0)) {
                        errors.push({
                          sheetName: sheetName,
                          ref: dataColumns[index],
                          message: "Field is mandatory",
                          data: value,
                          id: uniquErrorsId,
                          rowNumber: rowIndex + datasetIndex,
                        });
                      }
                    }

                    newObject[columnName] = value;
                  });

                  if (errors.length > 0) {
                    importErrors.push(errors);
                  }

                  switch (sheetName.toLowerCase()) {
                    case "depots": {
                      newObject = this.parseDepots(newObject);
                      break;
                    }
                    case "resourceprofiles": {
                      newObject = this.parseResourceProfiles(newObject, importedData);
                      break;
                    }
                    case "vehicletypes": {
                      newObject = this.parseVehicletypes(newObject);
                      break;
                    }
                    case "drivertypes": {
                      newObject = this.parseDrivertypes(newObject);
                      break;
                    }
                  }

                  parsedData.push(newObject);
                });
              }

              importedData.push({
                sheetName: sheetName,
                template: sheetMapping.apiEndpoint,
                bulkCreate: sheetMapping.bulkCreate,
                // dispatch: sheetMapping.virtualPath === "disapi" ? true : false,
                virtualPath: sheetMapping.virtualPath,
                result: parsedData,
              });

              // console.log(`Data from sheet ${sheetName}:`, filteredArray);
            },
          });
        }
      });

      this.setDataImporterModal("preDataErrors", importErrors);
      this.setDataImporterModal("importedData", importedData);
      this.setDataImporterModal("uploadLoading", false);

      // console.log(importedData);
    };

    reader.readAsArrayBuffer(currentFile);
  };

  //------------------------------------------------------------------------------
  parseVehicletypes(vehicleObject) {
    vehicleObject._id = mongoId();
    return vehicleObject;
  }
  parseDrivertypes(driverObject) {
    driverObject._id = mongoId();
    return driverObject;
  }

  parseResourceProfiles(rcObject, importedData) {
    let correctResourceProfiles = {
      resourceProfileRef: rcObject.resourceProfileRef,
      description: rcObject.description,
      // resourceCategory: "66e80bc0c89addfa68167786",
      vehicleType: null,
      driverType: null,
      mandatoryUnloading: rcObject.unloading,
      mandatoryLoading: rcObject.loading,
      mandatoryCrewPersonnel: rcObject.crewMandatory,
      maxCrewPersonnel: 2,
      optionalCrewPersonnel: rcObject.crew,
      minCrewPersonnel: 2,
      routeType: "",
    };

    //Get vehicleType Id
    let foundVehicleData = importedData.find((v) => v.sheetName.toLowerCase() === "vehicletypes");

    if (foundVehicleData.result.length > 0) {
      let foundVehicle = foundVehicleData.result.find((v) => v.vehicleTypeRef === rcObject.vehicleTypeRef);
      if (foundVehicle) correctResourceProfiles.vehicleType = foundVehicle._id;
    }

    //Get driverType Id
    let foundDriverData = importedData.find((d) => d.sheetName.toLowerCase() === "drivertypes");

    if (foundDriverData.result.length > 0) {
      let foundDriver = foundDriverData.result.find((v) => v.driverTypeRef === rcObject.vehicleTypeRef);
      if (foundDriver) correctResourceProfiles.driverType = foundDriver._id;
    }

    return correctResourceProfiles;
  }

  parseDepots(depotObject) {
    let correctDepotStrcuture = {
      depotRef: depotObject.depotRef,
      name: depotObject.name,
      brandingProfile: null, //depotObject.brandingProfile,
      type: "depot",
      active: true,
      address: {
        houseNumber: depotObject.houseNumber,
        houseName: depotObject.houseName,
        address1: depotObject.address1,
        address2: depotObject.address2,
        address3: depotObject.address3,
        address4: depotObject.address4,
        locality: depotObject.locality,
        region: depotObject.region,
        postCode: depotObject.postCode,
        countryCode: depotObject.countryCode,
        countryName: depotObject.countryName,
      },
      location: {
        type: "Point",
        coordinates: [parseFloat(depotObject.longitude), parseFloat(depotObject.latitude)],
      },
      contacts: [
        {
          firstName: depotObject.name + " Contact",
          lastName: "",
          primary: true,
          alertRecipient: false,
          email: [],
          phone: [],
        },
      ],
    };

    //Populate Emails
    if (depotObject.emails.length > 0) {
      depotObject.emails.forEach((em, i) => {
        let count = i + 0;
        correctDepotStrcuture.contacts[0].email.push({
          emailAddress: em,
          label: "Email " + count,
          primary: i === 0 ? true : false,
        });
      });
    }

    //Populate Phone
    if (depotObject.contactNumbers.length > 0) {
      depotObject.contactNumbers.forEach((ph, i) => {
        let count = i + 0;
        correctDepotStrcuture.contacts[0].phone.push({
          number: ph,
          label: "Phone " + count,
          primary: i === 0 ? true : false,
        });
      });
    }

    return correctDepotStrcuture;
  }

  //------------------------------------------------------------------------------

  parseError = (err, sheet, data) => {
    let foundSheetTemplate = this.dataImportTemplates.find((item) => item.sheetName === sheet.sheetName);
    let refColumn = foundSheetTemplate.fields.find((item) => item.fieldNum === 0);
    let primaryDataRef = refColumn?.ref || null;
    let errorMessage = "";
    let dataProp = "";

    if (err.response?.status === 403) {
      errorMessage = "Create Permission Is Not Authorised";
      dataProp = "";
    } else {
      if (data) {
        errorMessage = err.response?.data?.message || err.message;
        dataProp = primaryDataRef ? data[refColumn?.ref] : "N/A";
      } else {
        errorMessage = err.message;
        dataProp = "N/A";

        console.log("here");
      }
    }

    let errorDetails = {
      sheetName: sheet.sheetName,
      ref: primaryDataRef ? this.formatText(primaryDataRef) : "N/A",
      message: errorMessage,
      data: dataProp,
    };

    return errorDetails;
  };

  importData = async () => {
    this.setDataImporterModal("loading", true);

    this.store.setPreLoaderProps({
      loading: true,
      loadingText: `Importing Master Data`,
    });

    let postDataErrors = [];

    //Loop through the sheets
    for (const sheet of this.dataImporterModal.importedData) {
      console.log("SHEET", sheet);
      this.store.setPreLoaderProps({
        loading: true,
        loadingText: `Importing ${this.formatText(sheet.sheetName)}`,
      });

      if (sheet.result.length > 0) {
        if (sheet.bulkCreate) {
          //Bulk Create Mode
          try {
            await this.postTemplatesBulk(sheet);
          } catch (err) {
            postDataErrors.push(this.parseError(err, sheet, null));
          }
        } else {
          //Single Create Mode
          //loop through the records and post to the endpoint
          for (const data of sheet.result) {
            try {
              await this.store.postData(sheet.template, data, sheet.virtualPath, true);
            } catch (err) {
              postDataErrors.push(this.parseError(err, sheet, data));
            }
          }
        }
      }
    }

    this.setDataImporterModal("loading", false);

    this.store.setPreLoaderProps({
      loading: false,
      loadingText: "",
    });

    //No Errors Close Modal
    if (postDataErrors.length === 0) {
      this.setDataImporterModal(null, {
        visible: false,
        loading: false,
        row: null,
        uploadLoading: false,
        importedData: [],
        file: null,
        postDataErrors: [],
        preDataErrors: [],
      });
      // this.resetDataImporterFields();
      this.store.displayNotification(t("lblDataImportSuccesful", "Data Import Succesful"), "success", true);
    } else {
      this.store.displayNotification(
        t("lblSomeOfTheImportedDataDidNotMatchTheCriteriaPleaseReviewAndCorrect", "Some Of The Imported Data Did Not Match The Criteria. Please Review And Correct"),
        "warning",
        true
      );
      this.setDataImporterModal("postDataErrors", postDataErrors);
    }
  };

  validateDataUpload = async (data) => {
    if (data.length === 0) {
      this.store.displayNotification(t("lblNoDataFound", "No Data Found"), "error", true);
      return;
    }
    console.log(data);
  };

  // resetDataImporterFields = () => {
  //   this.setMultiCsvInfo(null, {
  //     file: null,
  //     data: [],
  //     error: [],
  //     validated: false,
  //   });
  // };

  //--------------------------------------------------------------------------
  public setEntity(entity: string, value: any) {
    this[entity] = value;
  }

  public setSaveButtonLoading(value: boolean) {
    this.saveButtonLoading = value;
  }

  public setAdditionalColumnsAreVisible(value: boolean) {
    this.additionalColumnsAreVisible = value;
  }

  public setIsFormModalVisible(value: boolean) {
    this.isFormModalVisible = value;
  }

  public setMainDataHasLoaded(value: any) {
    this.mainDataHasLoaded = value;
  }

  public setFormRef(value: any) {
    this.formRef = value;
  }

  public setClientSettingsFormRef(value: any) {
    this.clientSettingsFormRef = value;
  }

  public setEntitySnapshot(value: any) {
    this.entitySnapshot = value;
  }
  public setFormMode(value: any) {
    this.formMode = value;
  }

  //--------------------------------------------------------------------------------------------------------------
  // === FORM (CREATE AND EDIT) ===
  public openEditForm = (client: any) => {
    this.setFormMode("edit");

    this.selectedClient = toJS(client);
    // This value is used in the CrudFormModal component.
    // We use this value to know if the user has modified any fields within the form
    this.setEntitySnapshot(JSON.stringify(client));

    this.setIsFormModalVisible(true);
  };

  private setFormModalOptions = () => {
    if (localStorage.getItem("usersFormModalOptions")) {
      let localStorageObj: any = JSON.parse(localStorage.getItem("usersFormModalOptions"));

      this.formModalSize = localStorageObj.formModalSize.currentlySet;
      this.formFieldsSize = localStorageObj.formFieldsSize.currentlySet;
      this.showNonMandatoryFields = localStorageObj.showNonMandatoryFields.currentlySet;
      this.showFieldsIcon = localStorageObj.showFieldsIcon.currentlySet;
    } else {
      let usersFormModalOptions = {
        formModalSize: { default: "default", currentlySet: "default" },
        formFieldsSize: { default: "default", currentlySet: "default" },
        showNonMandatoryFields: { default: true, currentlySet: true },
        showFieldsIcon: { default: false, currentlySet: false },
      };

      localStorage.setItem("usersFormModalOptions", JSON.stringify(usersFormModalOptions));
    }
  };

  public copyText = (value: string) => {
    copyTextToClipboard(value);
    this.store.displayNotification(t("lblCopiedToClipboard", "Copied to Clipboard"), "info", false);
  };

  processDemoData = async (formData) => {
    this.store.setPreLoaderProps({
      loading: true,
      loadingText: "Posting Demo Data...",
    });

    const results = [];
    for (const depotId of formData.depotRefs) {
      for (const currentDate of this.selectedDates) {
        try {
          let foundDepot = this.depots.find((dt) => dt._id === depotId);

          const options = {
            numJobs: formData.numJobs, // INPUT JOBS NUMBER (used for post jobs)
            numRoutes: formData.numRoutes, // INPUT ROUTES NUMBER
            numStops: formData.numStops, // INPUT RUOTE's STOP NUMBER
            numJobsPerStop: formData.numJobsPerStop, // INPUT STOP's JOB NUMBER
            numItemsPerJob: formData.numItemsPerJob, // INPUT JOB's ITEM NUMBER
            numStopsWithClusterRef: formData.numStopsWithClusterRef, // INPUT THE NUMBER OF STOPS WITH clusterRef
            depot: foundDepot.depotRef,
            radius: formData.radius,
            date: currentDate.format("YYYY-MM-DD"),
            geocode: false,
            jobsAggregation: false,
          };

          const result = await this.postDemoData(options, foundDepot, formData.postTypes);
          results.push(result);
        } catch (error) {
          console.error("Error in API call for item:", depotId, error);
        }
      }
    }

    this.store.clearClient();
    this.store.setPreLoaderProps({
      loading: false,
      loadingText: "",
    });
    this.setDemoDataPostModal(null, {
      visible: false,
      loading: false,
      row: null,
    });
  };

  postDemoData = async (options, depotDetails, postType = ["routes", "jobs"]) => {
    try {
      let payload;
      let demoData;

      if (postType.includes("jobs")) {
        payload = this.generateDemoJobsPayload(options, depotDetails); // POST JOBS
        demoData = await this.store.postData("jobs", payload, "clientin", true);
      }

      if (postType.includes("routes")) {
        payload = this.generateDemoRoutesPayload(options, depotDetails); // POST ROUTES
        demoData = await this.store.postData("routes", payload, "clientin", true);
      }

      if (demoData) {
        this.store.displayNotification(t("lblDemoDataPostedSuccessfully", "Demo Data Posted Successfully for Depot: " + options.depot), "success", true);
      }
    } catch (err) {
      this.store.displayNotification(t("lblFailedToPostDemoData", "Failed to Post Demo Data for Depot: " + options.depot), "error", true, extractErrorMessage(err));
    }
  };

  private jobsMasterDataRoute: any = [
    {
      jobTypeRef: "DELIVERY",
      serviceLevelRef: "AD",
      routingSettings: {
        resourceSettings: {},
      },
      product: { productRef: "", productCategoryRef: "GENCAT" },
      services: ["D"],
      groupRef: "",
      groupSequence: 0,
      allowMobileGrouping: true,
      poeOptions: {
        signature: true,
        neighbour: false,
        safePlace: false,
      },
    },
    {
      jobTypeRef: "COLLECTION",
      serviceLevelRef: "AD",
      routingSettings: {
        resourceSettings: {},
      },
      product: { productRef: "", productCategoryRef: "GENCAT" },
      services: ["C"],
      additionalServices: [],
      groupRef: "",
      groupSequence: 0,
      allowMobileGrouping: true,
      poeOptions: {
        signature: true,
        neighbour: false,
        safePlace: false,
      },
    },
  ];

  private jobsMasterDataJob: any = [
    {
      jobTypeRef: "DELIVERY",
      serviceLevelRef: "AD",
      routingSettings: {
        resourceSettings: {},
      },
      product: { productRef: "", productCategoryRef: "GENCAT" },
      services: ["D"],
      additionalServices: [],
      allowMobileGrouping: true,
      poeOptions: {
        signature: true,
        neighbour: false,
        safePlace: false,
      },
    },
    {
      jobTypeRef: "COLLECTION",
      serviceLevelRef: "AD",
      routingSettings: {
        resourceSettings: {},
      },
      product: { productRef: "", productCategoryRef: "GENCAT" },
      services: ["C"],
      additionalServices: [],
      allowMobileGrouping: true,
      poeOptions: {
        signature: true,
        neighbour: false,
        safePlace: false,
      },
    },
  ];

  // JOB DATA
  private generateJobData = (date, depotRef) => {
    return {
      depotRef: depotRef,
      startDate: date,
      customer: {
        title: this.chance.prefix(),
        initials: "",
        firstName: this.chance.first(),
        lastName: this.chance.last(),
        homePhone: this.chance.phone({ country: "uk", mobile: false }),
        workPhone: this.chance.phone({ country: "uk", mobile: false }),
        mobilePhone: this.chance.phone({ country: "uk", mobile: true }),
        email: this.chance.email(),
      },
      routingSettings: {
        resourceSettings: {},
      },
      deltaStopTime: 0,
      highRiskIndicator: false,
      premiumIndicator: false,
      priority: 0,
      allowMobileGrouping: true,
    };
  };

  // ITEM DATA
  private itemMasterData = {
    itemQuantity: 1,
    itemWeight: 10,
    itemLength: 10,
    itemWidth: 10,
    itemDepth: 10,
    itemDescription: "",
    barcode: "",
  };

  generateDemoRoutesPayload = (options, depotDetails) => {
    let mainPayload = [];

    const center = depotDetails.location.coordinates; //[-1.8508798113381149, 52.450140821871805];
    const radiusInMeters = options.radius;
    const date = options.date;
    //const startDate = "2024-09-17";
    const depotRef = options.depot;
    const geocode = options.geocode; // USE GEOCODING AND DEFAULT COORDS
    const postcodes = []; //JSON.parse(pm.environment.get("postcodesDepot" + routeData.depotRef));

    // ROUTE DATA
    let routeData = {
      depotRef: depotRef,
      startDate: date,
      scheduled: true,
      routingSettings: {
        commit: false,
        optimisationStopSequenceLocked: false, // true SRS, false SRO
        activeForScheduling: true,
      },
      routeProfile: {},
      // if routeProfile.resourceProfileRef is missing or empty, OF selects defaultResourceProfileRef in clientsettings
      // from defaultResourceProfileRef in resourceprofiles, OF selects driverType and vehicleType. Consequently, default values for other non-location routeProfile fields are seclected from associated documents in drivertypes and in vehicletypes. Location fields are selected from depots
      // if driverRef and/or vehicleRef are specified and exist and other routeProfile fields are missing or empty, OF selects values from associated documents in drivers and/or vehicles
    };

    for (let h = 0; h < options.numRoutes; h++) {
      let payload = {
        routeRef: generateRandomNumber(6, 0).toString(),
        depotRef: routeData.depotRef,
        routingSettings: routeData.routingSettings,
        routeProfile: routeData.routeProfile,
        routeStops: [], // routeStops array initialisation
        startDate: routeData.startDate,
        scheduled: routeData.scheduled,
      };

      // // Create an array of available clusterRefs
      // const clusterRefs = Array.from({ length: options.numStopsWithClusterRef }, () => generateClusterRef());

      for (let i = 1; i <= options.numStops; i++) {
        // Create routeStop object for each stop
        let routeStop: any = {
          stop: i, // incremental stop number
          //stopRef: uuidv4(),
          location: {
            knownLocationRef: "", //"KLIntg" + generateRandomNumber(9, 0),
            companyName: this.chance.company(),
            houseNumber: this.chance.integer({ min: 1, max: 100 }).toString(),
            houseName: this.chance.address({ short_suffix: true }),
            address1: this.chance.street(),
            address2: this.chance.integer({ min: 1000, max: 2000 }).toString(),
            address3: this.chance.city(),
            address4: this.chance.province(),
            postCode: this.chance.postcode(),
            countryCode: "GB",
            location: {
              coordinates: generateRandomCoordinates(center, radiusInMeters),
              type: "Point",
            },
          },
          jobs: [], // jobs array initialisation
        };

        if (geocode) {
          routeStop.location.postCode = getRandomArrayElement(postcodes);
          routeStop.location.location.coordinates = [-999, -999];
        }

        // if (i <= options.numStopsWithClusterRef) {
        //   // Randomly assign clusterRef from the variable clusterRefs
        //   routeStop.clusterRef = clusterRefs[Math.floor(Math.random() * clusterRefs.length)];
        // }

        for (let j = 1; j <= options.numJobsPerStop; j++) {
          const jobData = this.generateJobData(date, depotRef);

          let jobRandomNumber = generateRandomNumber(6, 0);
          let jobMasterData = getRandomArrayElementPreferFirst(this.jobsMasterDataRoute, 0.9);

          const jobRef = (jobRandomNumber + i + j).toString();

          let job = {
            jobRef: jobRef,
            clientJobRef: jobRef,
            jobTypeRef: jobMasterData.jobTypeRef,
            customer: jobData.customer,
            routingSettings: jobData.routingSettings,
            serviceLevelRef: jobMasterData.serviceLevelRef || "",
            jobScheduling: {
              schedulingDateTimeEarliest: routeData.startDate + " 00:00",
              schedulingDateTimeLatest: routeData.startDate + " 23:59",
              excludeDateTimeEarliest: "",
              excludeDateTimeLatest: "",
            },
            deltaStopTime: jobData.deltaStopTime,
            customFields: jobMasterData.jobCustomFields || [],
            additionalServices: jobMasterData.additionalServices || [],
            highRiskIndicator: jobData.highRiskIndicator,
            premiumIndicator: jobData.premiumIndicator,
            priority: jobData.priority,
            poeOptions: jobMasterData.poeOptions,
            allowMobileGrouping: jobMasterData.allowMobileGrouping,
            items: [], // items array initialisation
          };
          for (let k = 1; k <= options.numItemsPerJob; k++) {
            const itemRef = `${jobRandomNumber}${i}${j}${k}`;
            // Create item object for each item
            let item = {
              itemRef: itemRef,
              itemDescription: itemRef,
              barcode: itemRef,
              product: {
                productRef: jobMasterData.product.productRef || "",
                productCategoryRef: jobMasterData.product.productCategoryRef || "",
                weight: this.itemMasterData.itemWeight,
                length: this.itemMasterData.itemLength,
                width: this.itemMasterData.itemWidth,
                depth: this.itemMasterData.itemDepth,
              },
              services: jobMasterData.services,
              customFields: jobMasterData.itemCustomFields || [],
              quantity: this.itemMasterData.itemQuantity,
            };
            job.items.push(item); // add item k to array
          }
          routeStop.jobs.push(job); // add job j to array
        }
        payload.routeStops.push(routeStop); // add stop to array
      }
      mainPayload.push(payload);
    }

    return mainPayload;
  };

  // Generates Jobs payload
  generateDemoJobsPayload = (options, depotDetails) => {
    let payload = [];

    const center = depotDetails.location.coordinates; //[-1.8508798113381149, 52.450140821871805];
    const radiusInMeters = options.radius;
    const depotRef = options.depot;
    const geocode = options.geocode; // USE GEOCODING AND DEFAULT COORDS
    const postcodes = []; //JSON.parse(pm.environment.get("postcodesDepot" + routeData.depotRef));

    const clusterRefs = Array.from({ length: options.numJobsWithClusterRef }, () => generateClusterRef());
    // Set shared location for jobsAggregation
    let sharedLocation: any = {};

    const aggregationFilter = {
      knownLocationRef: true,
      companyName: true,
      houseNumber: true,
      houseName: true,
      address1: true,
      address2: true,
      address3: true,
      address4: true,
      postCode: true,
      countryCode: false,
      location: false,
    };

    if (options.jobsAggregation) {
      Object.keys(aggregationFilter).forEach((key) => {
        if (aggregationFilter[key]) {
          sharedLocation[key] = generateSharedLocationValue(key, "GB", center, radiusInMeters);
        }
        if (geocode && aggregationFilter[key] && key === "postCode") {
          sharedLocation[key] = getRandomArrayElement(postcodes);
        }
      });
    }

    // Jobs
    for (let i = 0; i < options.numJobs; i++) {
      const jobData: any = this.generateJobData(options.date, depotRef);
      const jobRandomNumber = generateRandomNumber(6, 0);
      let jobMasterData = getRandomArrayElement(this.jobsMasterDataJob);

      //TODO: check if jobMasterData is empty
      if (i > 0 && options.jobsAggregation) {
        jobMasterData = this.jobsMasterDataJob.find(
          (obj) =>
            obj.routingSettings.resourceSettings.driverTypes === payload[i - 1].routingSettings.resourceSettings.driverTypes &&
            obj.routingSettings.resourceSettings.vehicleTypes === payload[i - 1].routingSettings.resourceSettings.vehicleTypes
        );
      }

      let location = {
        knownLocationRef: "",
        companyName: sharedLocation.companyName || this.chance.company(),
        houseNumber: sharedLocation.houseNumber || this.chance.integer({ min: 1, max: 100 }).toString(),
        houseName: sharedLocation.houseName || this.chance.address({ short_suffix: true }),
        address1: sharedLocation.address1 || this.chance.street(),
        address2: sharedLocation.address2 || this.chance.integer({ min: 1000, max: 2000 }).toString(),
        address3: sharedLocation.address3 || this.chance.city(),
        address4: sharedLocation.address4 || this.chance.province(),
        postCode: sharedLocation.postCode || this.chance.postcode(),
        countryCode: sharedLocation.countryCode || "GB",
        location: sharedLocation.location || {
          coordinates: generateRandomCoordinates(center, radiusInMeters),
          type: "Point",
        },
      };

      if (geocode) {
        location.postCode = sharedLocation.postCode || getRandomArrayElement(postcodes);
        location.location.coordinates = [-999, -999];
      }

      const jobRef = `${jobRandomNumber}${i}`;

      let job: any = {
        jobRef: jobRef,
        clientJobRef: jobRef,
        depotRef: jobData.depotRef,
        jobTypeRef: jobMasterData.jobTypeRef,
        serviceLevelRef: jobMasterData.serviceLevelRef,
        customer: jobData.customer,
        location: location,
        routingSettings: jobMasterData.routingSettings,
        jobScheduling: {
          schedulingDateTimeEarliest: jobData.startDate + " 00:00",
          schedulingDateTimeLatest: jobData.startDate + " 23:59",
          excludeDateTimeEarliest: "",
          excludeDateTimeLatest: "",
        },
        deltaStopTime: jobData.deltaStopTime,
        customFields: jobMasterData.jobCustomFields || [],
        highRiskIndicator: jobData.highRiskIndicator,
        premiumIndicator: jobData.premiumIndicator,
        priority: jobData.priority,
        additionalServices: jobMasterData.additionalServices || [],
        allowMobileGrouping: jobMasterData.allowMobileGrouping,
        poeOptions: jobMasterData.poeOptions,
        items: [],
      };

      if (i < options.numJobsWithClusterRef) {
        // Randomly assign clusterRef from the variable clusterRefs
        job.clusterRef = clusterRefs[Math.floor(Math.random() * clusterRefs.length)];
      }
      // Items
      for (let j = 0; j < options.numItemsPerJob; j++) {
        const itemRef = `${jobRandomNumber}${i}${j}`;

        let item = {
          itemRef: itemRef,
          itemDescription: itemRef,
          barcode: itemRef,
          product: {
            productRef: jobMasterData.product.productRef || "",
            productCategoryRef: jobMasterData.product.productCategoryRef || "",
            weight: this.itemMasterData.itemWeight,
            length: this.itemMasterData.itemLength,
            width: this.itemMasterData.itemWidth,
            depth: this.itemMasterData.itemDepth,
          },
          services: jobMasterData.services,
          customFields: jobMasterData.itemCustomFields || [],
          quantity: this.itemMasterData.itemQuantity,
        };
        job.items.push(item); // add item k to array
      }
      payload.push(job);
    }

    return payload;
  };

  //---------SCENARIO SNAPSHOTS-----------------------------------------------------------------------------------
  public saveScenarioSnapshot = async (scenarioRef, depot, selectedDate, type) => {
    const { clientRow } = this.saveScenarioSnapshotModal;
    try {
      this.setSaveScenarioSnapshotModal("spinMessage", "Fetching Scenario Snapshot");
      const formattedDate = dayjs(selectedDate).format("YYYY-MM-DD");
      const scenarioSnapshotData = await this.store.getData(`depots/${depot._id}/scenario-snapshots?date=${formattedDate}&type=${type}`, "pro_client", true);

      if (!scenarioSnapshotData) {
        throw new Error("Failed to fetch scenario snapshot data.");
      }

      const payload = {
        ref: scenarioRef,
        client: clientRow.clientRef,
        scenarioSnapshot: scenarioSnapshotData,
        depot: depot,
        date: formattedDate,
        type: type,
      };

      this.setSaveScenarioSnapshotModal("spinMessage", "Saving Scenario Snapshot");
      const response = await this.store.postData("scenario-snapshots", payload, "main", false, null);
      console.log(response);
      if (response) {
        this.store.displayNotification(t("lblScenarioSnapshotSavedSuccessfully", "Scenario Snapshot Saved Successfully"), "success", true);
      }

      // return response
    } catch (error) {
      console.error("Error handling scenario snapshot:", error);
      throw error;
    }
  };

  public updateScenarioSnapshot = async (formValues, data, removeAffectedSnapshot = null) => {
    try {
      let snapshot = data.snapshot;

      let foundSnapshot = this.scenarioSnapshots.find((sc) => sc._id === formValues.scenario);
      snapshot.targetDepot = formValues.depotId;

      snapshot.targetDate = dayjs(formValues.targetDate).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
      if (removeAffectedSnapshot != null) {
        snapshot.removeDuplicateData = true;
      }
      const payload = snapshot;
      const depotId = foundSnapshot.depot._id;

      const response = await this.store.postData(`depots/${depotId}/scenario-snapshots?type=${data.type}`, payload, "pro_client", true, null);

      if (!response) {
        throw new Error("Failed to update client with scenario snapshot.");
      }

      if (response) {
        this.store.displayNotification(t("lblClientScenarioSnapshotUpdatedSuccessfully", "Client Scenario Snapshot Updated Successfully"), "success", true);
      }
    } catch (error) {
      console.error("Error updating client with scenario snapshot:", error);
      throw error;
    }
  };

  public loadScenarioSnapshots = async () => {
    try {
      const scenarioSnapshotData = await this.store.getData("scenario-snapshots", "main");

      if (!scenarioSnapshotData) {
        this.store.displayNotification(t("lblFailedToFetchScenarioSnapshotData", "Failed to fetch scenario snapshot data"), "error", true);

        throw new Error("Failed to fetch scenario snapshot data.");
      }

      if (scenarioSnapshotData.result.length > 0) {
        this.setScenarioSnapshots(scenarioSnapshotData.result);
      } else {
        this.setScenarioSnapshots([]);
        this.store.displayNotification(t("lblNoScenarioSnapshotsAvailable", "No Scenario Snapshots Available"), "error", true);
      }
    } catch (error) {
      this.store.displayNotification(t("lblErrorFetchingScenarioSnapshot", "Error Fetching Scenario Snapshots"), "error", true);
      throw error;
    }
  };

  public deleteScenarioSnapshot = async (selectedScenario) => {
    try {
      this.setDeleteScenarioSnapshotModal("spinMessage", "Deleting Scenario");
      const response = await this.store.deleteData(`scenario-snapshots/${selectedScenario}`, "main", false);

      if (!response) {
        throw new Error("Failed to delete scenario snapshot.");
      }

      if (response) {
        this.store.displayNotification(t("lblScenarioSnapshotDeletedSuccessfully", "Scenario Snapshot Deleted Successfully"), "success", true);
      }
    } catch (error) {
      console.error("Error deleting scenario snapshot:", error);
      throw error;
    }
  };

  public getScenarioSnapshot = async (snapshotId) => {
    try {
      const scenarioSnapshotData = await this.store.getData("scenario-snapshots/" + snapshotId, "main");

      if (!scenarioSnapshotData) {
        this.store.displayNotification(t("lblFailedToFetchScenarioSnapshotData", "Failed to fetch scenario snapshot data"), "error", true);

        throw new Error("Failed to fetch scenario snapshot data.");
      }

      return scenarioSnapshotData;
    } catch (error) {
      this.store.displayNotification(t("lblErrorFetchingScenarioSnapshot", "Error Fetching Scenario Snapshots"), "error", true);
      throw error;
    }
  };

  //==============================================================================================================
  //CLIENT SETTINGS

  // public renderFieldsTitle = (title, valueField = null, showDot = false, isItemValue = false) => {
  //   const value = this.getValue(valueField, null, isItemValue)

  //   if (showDot || (valueField && !value && value !== 0)) {
  //     return (
  //       <Badge dot={true}>
  //         <span className='font-bold mr-2'>{title}</span>
  //       </Badge>
  //     )
  //   }

  //   return <span className='font-bold'>{title}</span>
  // }

  handleCheckboxChange = (key, options, selectOneOptionOnly, checkedValues) => {
    if (selectOneOptionOnly) {
      this.clientSettingsFormRef.setFieldsValue({
        [key]: checkedValues.length > 1 ? [checkedValues.pop()] : checkedValues,
      });
    }
  };

  formatText = (option) => {
    //Add space after first letter and capitalise firt letter of phrase
    return option
      .replace(/([A-Z])/g, " $1")
      .replace(/^\w/, (c) => c.toUpperCase())
      .trim();
  };

  public getValue = (location: string, defaultValue = null, itemValue = false) => {
    const { editProfile } = this.clientSettingsModal;
    return _.get(editProfile, location, defaultValue);
  };

  public getDisabledFlag = (valueKey, objFlag, activeFlagDependant: activeFlagDependant = null) => {
    let disabledFlagValue = false;

    if (objFlag && activeFlagDependant != null) {
      //consider looking into active flag
      disabledFlagValue = !this.getValue(activeFlagDependant.keyDirectory + ".active", false);
    }
    return disabledFlagValue;
  };

  public setValue = (location: string, value: any) => {
    _.set(this.clientSettingsModal.editProfile, location, value);
  };

  handleSettingsFields = (settingField) => {
    //Go through the ones that have type defined
    if (settingField?.type) {
      switch (settingField.type) {
        case "checkbox": {
          return this.renderCheckbox(settingField, settingField.key);
        }
        case "input": {
          return this.renderInput(settingField, settingField.key);
        }
        case "dropdown": {
          return this.renderDropdownSingle(settingField, settingField.key);
        }
        case "multiselect": {
          return this.renderDropdownMultiple(settingField, settingField.key);
        }
        case "timepicker": {
          return this.renderTimePicker(settingField, settingField.key);
        }
        default: {
          return settingField.label;
        }
      }
    } else if (settingField?.data) {
      return this.renderFormFields(settingField, settingField.key, true);
    } else {
      return settingField.label;
    }
  };

  renderFormFields = (settingField, parentKey = "", typeObj = false, activeFlag = null) => {
    let elements = [];

    let dataObj = settingField?.data ? settingField.data : settingField;

    let activeFlagExists;

    if (activeFlag === null) {
      activeFlagExists = {
        flag: dataObj.hasOwnProperty("active"),
        keyDirectory: settingField.key,
      };
    } else {
      activeFlagExists = activeFlag;
    }

    Object.entries(dataObj).forEach(([key, value]) => {
      const fieldName = parentKey ? `${parentKey}.${key}` : key;
      let activeFlagDependant = {
        flag: false,
        keyDirectory: activeFlagExists.keyDirectory,
      };
      // let superKey = previousParentKey ? previousParentKey + "_" + key : settingField.key + "_" + key;

      if (key === "active" && activeFlagExists.flag) {
        activeFlagDependant.flag = false;
      } else {
        activeFlagDependant.flag = activeFlagExists.flag;
      }

      if (typeof value === "string") {
        switch (value) {
          case "checkbox": {
            elements.push(this.renderCheckbox(key, fieldName, true, typeObj, activeFlagDependant));
            break;
          }
          case "input":
          case "textbox": {
            elements.push(this.renderInput(key, fieldName, true, typeObj, activeFlagDependant));
            break;
          }
          case "dropdown": {
            elements.push(this.renderDropdownSingle(key, fieldName, true, typeObj, activeFlagDependant));
            break;
          }
          case "multiselect": {
            elements.push(this.renderDropdownMultiple(key, fieldName, true, typeObj, activeFlagDependant));
            break;
          }
          case "timepicker": {
            elements.push(this.renderTimePicker(key, fieldName, true, typeObj, activeFlagDependant));
            break;
          }
          default: {
            elements.push(<>{key}</>);
            break;
          }
        }
      } else if (typeof value === "object") {
        elements.push(
          <React.Fragment key={fieldName}>
            <Divider orientation="left">{this.formatText(key)}</Divider>
            {this.renderFormFields(value, fieldName, true, activeFlagExists)}
          </React.Fragment>
        );
      }
    });

    return elements;
  };
  renderCheckbox(settingField, superKey = "", showLabel = false, objFlag = false, activeFlagDependant: activeFlagDependant = null) {
    const { editMode } = this.clientSettingsModal;
    let valueKey = settingField?.key ? settingField.key : superKey;

    //there are multiple checkboxes
    if (settingField?.props) {
      return (
        <Form.Item name={valueKey} className="clientSettingsFormItem" key={superKey} label={showLabel ? this.formatText(settingField) : null}>
          {settingField?.props.map((prop, idx) => {
            return (
              <Checkbox.Group
                disabled={!editMode ? true : activeFlagDependant?.flag ? this.getDisabledFlag(valueKey, objFlag, activeFlagDependant) : false}
                key={idx}
                options={prop.options.map((option) => ({ label: this.formatText(option), value: option }))}
                // checked={this.getValue(settingField.key, false)}
              />
            );
          })}
        </Form.Item>
      );
    }

    return (
      <Form.Item colon={false} className="clientSettingsFormItem" name={valueKey} key={superKey} label={showLabel ? this.formatText(settingField) : null}>
        <Checkbox
          disabled={!editMode ? true : activeFlagDependant?.flag ? this.getDisabledFlag(valueKey, objFlag, activeFlagDependant) : false}
          checked={this.getValue(valueKey, false)}
          onChange={(e) => {
            this.setValue(valueKey, e.target.checked);
          }}
        />
      </Form.Item>
    );
  }
  renderInput(settingField, superKey = "", showLabel = false, objFlag = false, activeFlagDependant: activeFlagDependant = null) {
    const { editMode } = this.clientSettingsModal;
    let valueKey = settingField?.key ? settingField.key : superKey;

    if (settingField.props?.numericalOnly) {
      return (
        <Form.Item colon={false} className="clientSettingsFormItem" key={superKey} label={showLabel ? this.formatText(settingField) : null}>
          <InputNumber
            style={{ width: "100%" }}
            max={_.get(settingField, "props.maxvalue", 999999)}
            min={_.get(settingField, "props.minvalue", -999999)}
            value={this.getValue(valueKey, "")}
            precision={_.get(settingField, "props.precision", 0)}
            disabled={!editMode ? true : activeFlagDependant?.flag ? this.getDisabledFlag(valueKey, objFlag, activeFlagDependant) : false}
            onChange={(e) => {
              console.log(e.target.value);

              if (_.get(settingField, "props.numericalOnly", false)) {
                const reg = /^-?[0-9]*(\.[0-9]*)?$/;

                if (reg.test(e.target.value)) {
                  this.setValue(valueKey, e.target.value);
                }
              } else {
                this.setValue(valueKey, e.target.value);
              }
            }}
          />
        </Form.Item>
      );
    }
    return (
      <Form.Item colon={false} className="clientSettingsFormItem" key={superKey} label={showLabel ? this.formatText(settingField) : null}>
        <Input
          style={{ width: "100%" }}
          value={this.getValue(valueKey, "")}
          disabled={!editMode ? true : activeFlagDependant?.flag ? this.getDisabledFlag(valueKey, objFlag, activeFlagDependant) : false}
          onChange={(e) => {
            console.log(e.target.value);

            if (_.get(settingField, "props.numericalOnly", false)) {
              const reg = /^-?[0-9]*(\.[0-9]*)?$/;

              if (reg.test(e.target.value)) {
                this.setValue(valueKey, e.target.value);
              }
            } else {
              this.setValue(valueKey, e.target.value);
            }
          }}
        />
      </Form.Item>
    );
  }
  renderDropdownSingle(settingField, superKey = "", showLabel = false, objFlag = false, activeFlagDependant: activeFlagDependant = null) {
    const { editMode } = this.clientSettingsModal;
    let valueKey = settingField?.key ? settingField.key : superKey;

    return (
      <Form.Item colon={false} className="clientSettingsFormItem" key={superKey} label={showLabel ? this.formatText(settingField) : null}>
        <Select
          placeholder="Select option"
          value={this.getValue(valueKey, [])}
          disabled={!editMode ? true : activeFlagDependant?.flag ? this.getDisabledFlag(valueKey, objFlag, activeFlagDependant) : false}
        >
          {settingField.props.options.map((option, idx) => (
            <Select.Option key={idx} value={option}>
              {this.formatText(option)}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
    );
  }
  renderDropdownMultiple(settingField, superKey = "", showLabel = false, objFlag = false, activeFlagDependant: activeFlagDependant = null) {
    const { editMode } = this.clientSettingsModal;
    let valueKey = settingField?.key ? settingField.key : superKey;

    return (
      <Form.Item colon={false} className="clientSettingsFormItem" key={superKey} label={showLabel ? this.formatText(settingField) : null}>
        <Select
          mode="multiple"
          placeholder="Select options"
          value={this.getValue(valueKey, [])}
          disabled={!editMode ? true : activeFlagDependant?.flag ? this.getDisabledFlag(valueKey, objFlag, activeFlagDependant) : false}
        >
          {settingField.props.options.map((option, idx) => (
            <Select.Option key={idx} value={option}>
              {this.formatText(option)}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
    );
  }
  renderTimePicker(settingField, superKey = "", showLabel = false, objFlag = false, activeFlagDependant: activeFlagDependant = null) {
    const { editMode } = this.clientSettingsModal;
    let valueKey = settingField?.key ? settingField.key : superKey;

    return (
      <Form.Item colon={false} className="clientSettingsFormItem" key={superKey} label={showLabel ? this.formatText(settingField) : null}>
        <TimePicker
          style={{ width: "100%" }}
          value={dayjs(this.getValue(valueKey, "00:00"), "HH:mm")}
          disabled={!editMode ? true : activeFlagDependant?.flag ? this.getDisabledFlag(valueKey, objFlag, activeFlagDependant) : false}
        />
      </Form.Item>
    );
  }
}
